import { clamp } from '@helpers/utils';
import { withMotionMax } from '@hoc/withMotionMax';
import DropdownFilter from '@stories/Components/Listings/DropdownFilter/DropdownFilter';
import FormField from '@stories/Components/Misc/Forms/FormField';
import Select from '@stories/Components/Misc/Forms/Inputs/Select/Select';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './Filters.styles';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { getSystemIcon, SystemIcon } from '@helpers/icons';
const Filters = (props) => {
    const [open, setOpen] = React.useState(-1);
    const containerRef = useOutsideClick(() => setOpen(-1));
    const filterRefs = React.useRef([]);
    const [expanded, setExpanded] = React.useState(false);
    const count = props.filters?.reduce((previousLength, filter) => previousLength + (filter.value ? filter.value.length : 0), 0);
    const selectedFilters = React.useMemo(() => {
        return (props.filters
            ?.filter((filter) => filter.value ? filter.value.length > 0 : false)
            .map((filter) => {
            return {
                ...filter,
                options: filter.options.filter((f) => filter.value.includes(f.value)),
            };
        }) ?? []);
    }, [count]);
    return (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
        React.createElement(S.Container, { ref: containerRef, "data-show-filter-btn": props.filters && props.filters?.length > 3 },
            React.createElement(S.InnerFlex, { "data-expanded": expanded },
                React.createElement(S.MobileOverlay, null),
                React.createElement(S.FiltersWrapper, null,
                    React.createElement(S.Top, null,
                        React.createElement(S.TopTitle, null, props.translations?.['global.filters.filters']),
                        React.createElement(S.CloseBtn, { "aria-label": props.translations?.['global.filters.close'], onClick: () => setExpanded(false) }, getSystemIcon(SystemIcon.CloseCircle))),
                    selectedFilters.length > 0 || (props.searchInput && !!props.searchInput.value) ? (React.createElement(S.SelectedWrapperMobile, null,
                        React.createElement(S.SelectedWrapperMobileInner, null,
                            selectedFilters.map((filter) => (React.createElement(React.Fragment, { key: `selected-${filter.id}` }, filter.options.map((option) => (React.createElement(S.SelectedOption, { key: `selected-${filter.id}-${option.value}`, initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                                    y: 0,
                                    scale: 1,
                                    opacity: 1,
                                }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, onClick: () => filter.onChange?.(option.value) },
                                option.label,
                                getSystemIcon(SystemIcon.Close))))))),
                            selectedFilters.length > 0 ? (React.createElement(S.SelectedClearAll, null,
                                React.createElement(S.SelectedOption, { key: `selected-clear`, onClick: () => props.clearFilters(), initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                                        y: 0,
                                        scale: 1,
                                        opacity: 1,
                                    }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, "data-all": true }, props.translations?.['global.filters.clear']))) : null))) : null,
                    React.createElement(S.FilterArea, null,
                        props.filters?.map((filter, i) => {
                            if (!expanded && i >= 5) {
                                return null;
                            }
                            return renderFilter(filter, i);
                        }),
                        props.filters && props.filters?.length > 5 &&
                            React.createElement(S.ButtonContainer, null,
                                React.createElement(S.ShowMoreButton, { type: 'button', onClick: () => setExpanded(!expanded), onKeyDown: (event) => {
                                        switch (event.key) {
                                            case 'Enter':
                                                event.preventDefault();
                                                event.stopPropagation();
                                                setExpanded(!expanded);
                                                filterRefs.current[0].focus();
                                                break;
                                        }
                                    } },
                                    React.createElement("span", { "data-desktop": true }, props.translations?.[expanded ? 'global.filters.less' : 'global.filters.more']))))),
                React.createElement(AnimatePresence, null, selectedFilters.length > 0 || (props.searchInput && !!props.searchInput.value) ? (React.createElement(S.SelectedWrapper, null,
                    selectedFilters.map((filter) => (React.createElement(React.Fragment, { key: `selected-${filter.id}` }, filter.options.map((option) => (React.createElement(S.SelectedOption, { key: `selected-${filter.id}-${option.value}`, initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                            y: 0,
                            scale: 1,
                            opacity: 1,
                        }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, onClick: () => filter.onChange?.(option.value) },
                        option.label,
                        getSystemIcon(SystemIcon.Close))))))),
                    selectedFilters.length > 0 ? (React.createElement(S.SelectedClearAll, null,
                        React.createElement(S.SelectedOption, { key: `selected-clear`, onClick: () => props.clearFilters(), initial: { y: `33%`, scale: 0.9, opacity: 0 }, animate: {
                                y: 0,
                                scale: 1,
                                opacity: 1,
                            }, exit: { y: `33%`, scale: 0.9, opacity: 0 }, "data-all": true }, props.translations?.['global.filters.clear']))) : null)) : null)),
            React.createElement(S.BaseFilterArea, null,
                React.createElement(S.ResultAmountArea, null,
                    props.translations?.['global.filters.showing'],
                    " ",
                    React.createElement("span", null,
                        props.resultAmount,
                        " of ",
                        props.resultTotal),
                    " ",
                    props.resultType),
                React.createElement(S.BaseFilterRightArea, null,
                    React.createElement(S.FilterOpenBtn, { onClick: () => setExpanded(!expanded) },
                        React.createElement("span", null, props.translations?.['global.filters.filters']),
                        getSystemIcon(SystemIcon.Chevron)),
                    props.sortBy && (React.createElement(S.SortByArea, null,
                        React.createElement(S.SortByAreaLabel, null, props.sortBy?.label),
                        React.createElement(FormField, { label: props.sortBy?.label, showLabel: false, name: "sort-by-select" },
                            React.createElement(Select, { id: "sort-by-select", value: props.sortBy.value ?? '', onChange: (event) => props.sortBy?.onChange(event.target.value) }, props.sortBy.options.map((option) => (React.createElement("option", { key: option.value, value: option.value }, option.label))))))))))));
    function renderFilter(filter, i) {
        return (React.createElement(DropdownFilter, { key: filter.id, ref: (el) => (filterRefs.current[i] = el), ...filter, isOpen: open === i, onRightPress: () => {
                const maxIndex = expanded ? props.filters.length - 1 : props.filters.length > 4 ? 4 : props.filters.length - 1;
                const nextIndex = i === maxIndex ? 0 : clamp(i + 1, maxIndex);
                filterRefs.current[nextIndex].focus();
            }, onLeftPress: () => {
                const maxIndex = expanded ? props.filters.length - 1 : props.filters.length > 4 ? 4 : props.filters.length - 1;
                const prevIndex = i === 0 ? maxIndex : clamp(i - 1, maxIndex);
                filterRefs.current[prevIndex].focus();
            }, onEscapePress: () => {
                setOpen(-1);
                filterRefs.current[i].focus();
            }, setOpen: (open) => {
                if (open) {
                    setOpen(i);
                }
                else {
                    setOpen(-1);
                }
            }, resultsCount: props.resultAmount, translations: props.translations, canFocus: i < props.filters.length - 1 || expanded }));
    }
};
export default withMotionMax(Filters);
